import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction, SuccessMessageAction} from "../components/CustomToast/actions";

export const LOADED_LESSONS = '[lessons] Loaded Lessons';
export const LOADED_LESSONS_PAGES = '[lessons] Loaded pages';
export const LOADED_LESSONS_TOTAL = '[lessons] Loaded total';
export const LOADED_LESSONS_CURRENT = '[lessons] Loaded current';
export const LOADED_LESSONS_LIMIT = '[lessons] Loaded limit';
export const SET_LESSON = '[lesson] Loaded Lesson';
export const LOADED_SCHEDULES = '[schedules] Loaded schedules';
export const LOADED_SCHEDULES_PAGES = '[schedules] Loaded pages';
export const LOADED_SCHEDULES_TOTAL = '[schedules] Loaded total';
export const LOADED_SCHEDULES_CURRENT = '[schedules] Loaded current';
export const LOADED_SCHEDULES_LIMIT = '[schedules] Loaded limit';
export const LESSON_CODES_ADDED_TO_SELECTION = '[lessons] lesson codes added to selection';
export const LESSON_CODES_REMOVED_FROM_SELECTION = '[lessons] all lesson codes removed from selection';
export const LOADED_SCHEDULE = '[schedule] Loaded schedule';
export const SET_TEACHER_FACILITATION_SHOW_STUDENTS = '[teacher_facilitation] Set show students';
export const SET_TEACHER_FACILITATION_SORT_BY = '[teacher_facilitation] Set sort by';
export const SET_TEACHER_FACILITATION_SELECTED_STREAM_ID = '[teacher_facilitation] Set selected stream id';
export const SET_TEACHER_FACILITATION_SELECTED_CARD_INDEX = '[teacher_facilitation] Set selected card index';
export const SET_TEACHER_FACILITATION_QUESTION_FULLSCREEN = '[teacher_facilitation] Set question fullscreen';
export const SET_TEACHER_FACILITATION_MOBILE_SHOW_STREAMS = '[teacher_facilitation] Set mobile show streams';

export const LoadLessonsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Lessons')))
        .then(() => MindsetsJsSDK().API.get('lessons', options))
        .then(response => {
            dispatch(LoadedLessonsAction(response.items));
            dispatch(LoadedLessonsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedLessonsLimitAction(response.limit));
            dispatch(LoadedLessonsPagesAction(response.pages));
            dispatch(LoadedLessonsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedLessonsAction = payload => ({
    type: LOADED_LESSONS,
    payload
});
export const LoadedLessonsPagesAction = payload => ({
    type: LOADED_LESSONS_PAGES,
    payload
});
export const LoadedLessonsTotalAction = payload => ({
    type: LOADED_LESSONS_TOTAL,
    payload
});
export const LoadedLessonsCurrentAction = payload => ({
    type: LOADED_LESSONS_CURRENT,
    payload
});
export const LoadedLessonsLimitAction = payload => ({
    type: LOADED_LESSONS_LIMIT,
    payload
});

export const LoadLessonAction = (lesson_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Lesson')))
        .then(() => MindsetsJsSDK().API.get(`lessons/${lesson_id}`, options))
        .then(response => {
            dispatch(SetLessonAction(response.lesson));
            dispatch(LoadingAction(false));

            return response.lesson;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SetLessonAction = payload => ({
    type: SET_LESSON,
    payload
});
export const UpdateLessonAction = (lesson_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.put(`lessons/${lesson_id}`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Class updated')));
};
export const PauseLessonAction = (lesson_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.patch(`lessons/${lesson_id}/pause`, options))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const UnpauseLessonAction = (lesson_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.patch(`lessons/${lesson_id}/unpause`, options))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const DeleteLessonAction = (lesson_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete('lessons/' + lesson_id, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Class deleted')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const ScheduleForScoringAction = (lesson_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.put(`lessons/${lesson_id}/schedule`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Class scheduled')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const AssignUsersToLessonAction = (lesson_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.post(`lessons/${lesson_id}/streams`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Users were assigned.')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const LoadSchedulesAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Schedules')))
        .then(() => MindsetsJsSDK().API.get('lessons/schedules', options))
        .then(response => {
            dispatch(LoadedSchedulesAction(response.items));
            dispatch(LoadedSchedulesCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedSchedulesLimitAction(response.limit));
            dispatch(LoadedSchedulesPagesAction(response.pages));
            dispatch(LoadedSchedulesTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedSchedulesAction = payload => ({
    type: LOADED_SCHEDULES,
    payload
});
export const LoadedSchedulesPagesAction = payload => ({
    type: LOADED_SCHEDULES_PAGES,
    payload
});
export const LoadedSchedulesTotalAction = payload => ({
    type: LOADED_SCHEDULES_TOTAL,
    payload
});
export const LoadedSchedulesCurrentAction = payload => ({
    type: LOADED_SCHEDULES_CURRENT,
    payload
});
export const LoadedSchedulesLimitAction = payload => ({
    type: LOADED_SCHEDULES_LIMIT,
    payload
});

export const LoadScheduleAction = (schedule_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Schedule')))
        .then(() => MindsetsJsSDK().API.get(`lesson_scoring_schedules/${schedule_id}`, options))
        .then(response => {
            dispatch(LoadedScheduleAction(response.lesson_scoring_schedule));
            dispatch(LoadingAction(false))

            return response.lesson_scoring_schedule;
        });
};
export const LoadedScheduleAction = payload => ({
    type: LOADED_SCHEDULE,
    payload
});
export const DeleteScheduleAction = (lesson_schedule_id, options) => dispatch => {
    dispatch(LoadingAction(true));

    return MindsetsJsSDK().API.delete('lessons/schedules/' + lesson_schedule_id, options)
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Class Schedule deleted')));
};
export const VerifyScheduleAction = (data, options) => () => MindsetsJsSDK().API.post('lessons/schedules/verify', data, options);
export const VerifyGradesAction = (data, options) => () => MindsetsJsSDK().API.post(`lessons/verify_grades`, data, options);
export const CreateSchedulesAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.post('lessons/schedules', data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Classes successfully scheduled for grading')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const AssignGradesAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.post(`lessons/assign_grades`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('Grade level(s) successfully assigned to selected Classes')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const UpdateScheduleAction = (id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Updating Schedule')))
        .then(() => MindsetsJsSDK().API.put(`lesson_scoring_schedules/${id}`, data, options))
        .then(() => dispatch(LoadingAction(false)));
};

export const AddClassCodesToSelectionAction = payload => {
    return {
        type: LESSON_CODES_ADDED_TO_SELECTION,
        payload
    }
};

export const JoinLessonAction = (code, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Joining the Class')))
        .then(() => MindsetsJsSDK().API.post(`lessons/${code}/join`, data, options));
};
export const JoinLessonForceAction = (code, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Joining the Class')))
        .then(() => MindsetsJsSDK().API.post(`lessons/${code}/join/force`, data, options));
};

export const LoadPDCertificateAction = lesson_code => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'One moment... we\'re building your Certificate!')))
        .then(() => MindsetsJsSDK().API.get(`lessons/${lesson_code}/certificate`, {buffer: true}))
        .then(response => {
            dispatch(LoadingAction(false));

            return response;
        });
};

export const SetTeacherFacilitationShowStudentsAction = payload => ({
    type: SET_TEACHER_FACILITATION_SHOW_STUDENTS,
    payload
});
export const SetTeacherFacilitationSortByAction = payload => ({
    type: SET_TEACHER_FACILITATION_SORT_BY,
    payload
});
export const SetTeacherFacilitationSelectedStreamIdAction = payload => ({
    type: SET_TEACHER_FACILITATION_SELECTED_STREAM_ID,
    payload
});
export const SetTeacherFacilitationSelectedCardIndexAction = payload => ({
    type: SET_TEACHER_FACILITATION_SELECTED_CARD_INDEX,
    payload
});
export const SetTeacherFacilitationQuestionFullscreenAction = payload => ({
    type: SET_TEACHER_FACILITATION_QUESTION_FULLSCREEN,
    payload
});
export const SetTeacherFacilitationMobileShowStreamsAction = payload => ({
    type: SET_TEACHER_FACILITATION_MOBILE_SHOW_STREAMS,
    payload
});

export const AssignFiltersAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => MindsetsJsSDK().API.post(`lessons/assign_filters`, data, options))
        .then(() => dispatch(SuccessMessageAction('Filter(s) successfully assigned to selected Classes')));
};

export const ChangeOwnerAction = (data, options) => dispatch => {
    return MindsetsJsSDK().API.post(`lessons/transfer`, data, options);
};
